import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Save, Loader2, Bitcoin } from 'lucide-react';
import { useAdmin } from '@/hooks/useAdmin';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminCryptoTips() {
  const { authFetch } = useAdmin();
  const [wallets, setWallets] = useState({});
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch(`${API}/admin/crypto-wallets`).then(r => r.json()).then(d => {
      setWallets(d.wallets || {});
      setLoading(false);
    });
  }, [authFetch]);

  const update = (key, field, val) =>
    setWallets(w => ({ ...w, [key]: { ...w[key], [field]: val } }));

  const save = async () => {
    setSaving(true);
    try {
      const r = await authFetch(`${API}/admin/crypto-wallets`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ wallets }),
      });
      if (!r.ok) throw new Error();
      toast.success('Spremljeno');
    } catch { toast.error('Greška pri spremanju'); } finally { setSaving(false); }
  };

  if (loading) return <div className="p-8"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="p-6 max-w-4xl" data-testid="admin-crypto-tips">
      <div className="flex items-center gap-3 mb-6">
        <Bitcoin className="text-red-500" size={28} />
        <div>
          <h1 className="text-2xl font-bold text-gray-100">Kripto napojnice</h1>
          <p className="text-sm text-gray-400">Uredite kripto adrese koje se prikazuju na /kripto stranici.</p>
        </div>
      </div>
      <div className="space-y-4">
        {Object.entries(wallets).map(([key, w]) => (
          <div key={key} data-testid={`wallet-edit-${key}`} className="p-4 rounded-xl border border-zinc-800 bg-zinc-900/50">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="text-xs text-zinc-400 block mb-1">Oznaka mreže</label>
                <input value={w.network || ''} onChange={e => update(key, 'network', e.target.value)}
                       className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2 text-sm text-zinc-100" />
              </div>
              <div>
                <label className="text-xs text-zinc-400 block mb-1">Simbol</label>
                <input value={w.symbol || ''} onChange={e => update(key, 'symbol', e.target.value)}
                       className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2 text-sm text-zinc-100" />
              </div>
              <div className="md:col-span-2">
                <label className="text-xs text-zinc-400 block mb-1">Adresa</label>
                <input value={w.address || ''} onChange={e => update(key, 'address', e.target.value)}
                       data-testid={`wallet-address-${key}`}
                       className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2 text-sm font-mono text-zinc-100" />
              </div>
              <label className="flex items-center gap-2 text-sm text-zinc-200 md:col-span-2">
                <input type="checkbox" checked={!!w.enabled}
                       onChange={e => update(key, 'enabled', e.target.checked)}
                       className="accent-red-600" />
                Aktivno (prikaži javno)
              </label>
            </div>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="save-crypto-wallets-btn"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 disabled:opacity-60 text-white font-bold">
        {saving ? <Loader2 className="animate-spin" size={16}/> : <Save size={16} />} Spremi
      </button>
    </div>
  );
}
